/* Bisou Tea redesign: site behaviour (header, drawers, cart).
   Plain script (deferred), no dependencies. Everything is delegated on document, state lives on <html> classes,
   so it survives theme-editor section re-renders:
     html.bt-scrolled      scrollY > 40 (Nav.dc.html threshold): header shrinks 96 -> 68px, tagline collapses
     html.bt-mega-open     mega menu panel open (desktop >= 960px)
     html.bt-search-open   search panel open
     html.bt-menu-open     mobile menu drawer open
     html.bt-cart-open     cart drawer open
     html.bt-lock          page scroll locked (any drawer open)
   Public API (window.BisouCart):
     open(), close(), refresh() -> Promise, get() -> Promise<cart.js>,
     add(variantId, quantity = 1, { properties, sellingPlan, open = true }) -> Promise<{ itemCount }>,
     change(lineKey, quantity) -> Promise, itemCount (number)
   Hooks / events:
     [data-bt-add] buttons   data-variant-id, data-quantity (1), data-added-label ("Added"), data-error-label ("Unavailable")
     form[data-bt-add-form]  intercepted submit; reads id / quantity / properties[...] / selling_plan
     window event "bisou:add"    detail { id | variantId, quantity | qty, properties, sellingPlan }  -> adds, opens the drawer
                                 (detail without an id only refreshes and opens: the mockup's original semantics)
     window event "bisou:added"  detail { itemCount, source }   fired after a successful add
     window event "bisou:error"  detail { message }
     window event "bisou:cart:updated" detail { itemCount }     fired after every cart re-render */
(function () {
  if (window.BisouCart) return;
  var root = document.documentElement;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SCROLL_Y = 40;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function fire(name, detail) { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }

  /* ------------------------------------------------------------ announcement rotation */
  var announceTimer = null;
  function announceTick() {
    if (document.hidden) return;
    $$('[data-bt-announce]').forEach(function (el) {
      var msgs = $$('.bt-announce__msg', el);
      if (msgs.length < 2) return;
      var i = ((parseInt(el.getAttribute('data-i'), 10) || 0) + 1) % msgs.length;
      el.setAttribute('data-i', String(i));
      paintAnnounce(el, i);
    });
  }
  function paintAnnounce(el, i) {
    $$('.bt-announce__msg', el).forEach(function (m, k) {
      m.classList.toggle('is-active', k === i);
      m.classList.toggle('is-before', k < i);
      m.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
  }
  function initAnnounce() {
    $$('[data-bt-announce]').forEach(function (el) { paintAnnounce(el, parseInt(el.getAttribute('data-i'), 10) || 0); });
    if (announceTimer) clearInterval(announceTimer);
    var first = $('[data-bt-announce]');
    var ms = first ? parseInt(first.getAttribute('data-interval'), 10) || 4200 : 4200;
    announceTimer = setInterval(announceTick, ms);
  }

  /* ------------------------------------------------------------ header state */
  function onScroll() { root.classList.toggle('bt-scrolled', window.scrollY > SCROLL_Y); }
  function syncHeaderHeight() {
    var bar = $('[data-bt-header]');
    if (!bar) return;
    var h = Math.round(bar.getBoundingClientRect().height);
    root.style.setProperty('--bt-header-height', h + 'px');
    root.style.setProperty('--header-height', h + 'px'); // Prestige sticky offsets read this
  }
  var ro = null;
  function observeHeader() {
    syncHeaderHeight();
    if (!('ResizeObserver' in window)) return;
    if (ro) ro.disconnect();
    var bar = $('[data-bt-header]');
    if (!bar) return;
    ro = new ResizeObserver(syncHeaderHeight);
    ro.observe(bar);
  }

  /* ------------------------------------------------------------ mega menu */
  function setMega(open) {
    if (!$('[data-bt-mega]')) open = false;
    root.classList.toggle('bt-mega-open', !!open);
    $$('[data-bt-mega-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  /* ------------------------------------------------------------ search panel */
  function setSearch(open) {
    root.classList.toggle('bt-search-open', !!open);
    $$('[data-bt-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      setMega(false);
      var input = $('[data-bt-search] input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
  }

  /* ------------------------------------------------------------ drawers (menu, cart) */
  var lastFocus = null;
  function drawerEl(name) { return $('[data-bt-drawer="' + name + '"]'); }
  function isOpen(name) { return root.classList.contains('bt-' + name + '-open'); }
  function openDrawer(name) {
    var d = drawerEl(name);
    if (!d) return;
    ['menu', 'cart'].forEach(function (n) { if (n !== name && isOpen(n)) closeDrawer(n, true); });
    setMega(false); setSearch(false);
    if (!isOpen(name)) lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('inert');
    d.setAttribute('aria-hidden', 'false');
    root.classList.add('bt-' + name + '-open', 'bt-lock');
    $$('[data-bt-' + name + '-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusEl = $('.bt-drawer__head button', d);
    if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, reduceMotion ? 0 : 120);
  }
  function closeDrawer(name, keepFocus) {
    var d = drawerEl(name);
    root.classList.remove('bt-' + name + '-open');
    if (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('inert', '');
    }
    $$('[data-bt-' + name + '-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!isOpen('menu') && !isOpen('cart')) {
      root.classList.remove('bt-lock');
      if (!keepFocus && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (_) {} }
    }
  }
  function closeAll() { setMega(false); setSearch(false); closeDrawer('menu'); closeDrawer('cart'); }

  /* ------------------------------------------------------------ cart */
  var Cart = {
    itemCount: 0,
    _sectionId: function () {
      var r = $('[data-bt-cart-root]');
      return r ? r.getAttribute('data-section-id') : null;
    },
    open: function () { openDrawer('cart'); },
    close: function () { closeDrawer('cart'); },
    get: function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    _setCount: function (n, bump) {
      Cart.itemCount = n;
      $$('[data-bt-cart-count]').forEach(function (el) {
        el.textContent = String(n);
        el.setAttribute('data-count', String(n));
        if (bump) {
          el.classList.add('is-bump');
          setTimeout(function () { el.classList.remove('is-bump'); }, 260);
        }
      });
    },
    _apply: function (html, bump) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-bt-cart-inner]');
      var cur = $('[data-bt-cart-inner]');
      var nextRoot = doc.querySelector('[data-bt-cart-root]');
      if (next && cur) {
        var oldBar = $('[data-bt-ship-bar]', cur);
        var from = oldBar ? parseFloat(oldBar.getAttribute('data-pct')) || 0 : null;
        cur.innerHTML = next.innerHTML;
        var bar = $('[data-bt-ship-bar]', cur);
        if (bar && from !== null && !reduceMotion) {
          var to = parseFloat(bar.getAttribute('data-pct')) || 0;
          bar.style.width = from + '%';
          requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = to + '%'; }); });
        }
      }
      var count = nextRoot ? parseInt(nextRoot.getAttribute('data-item-count'), 10) : NaN;
      if (!isNaN(count)) Cart._setCount(count, bump);
      fire('bisou:cart:updated', { itemCount: Cart.itemCount });
    },
    refresh: function (bump) {
      var id = Cart._sectionId();
      if (!id) return Cart.get().then(function (c) { Cart._setCount(c.item_count, bump); return c; });
      return fetch(ROOT + '?section_id=' + encodeURIComponent(id))
        .then(function (r) { return r.text(); })
        .then(function (html) { Cart._apply(html, bump); });
    },
    _post: function (path, payload) {
      var id = Cart._sectionId();
      if (id) payload.sections = id;
      return fetch(ROOT + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not update the cart');
          return json;
        });
      });
    },
    add: function (variantId, quantity, opts) {
      opts = opts || {};
      var item = { id: Number(variantId), quantity: Number(quantity) || 1 };
      if (opts.properties) item.properties = opts.properties;
      if (opts.sellingPlan) item.selling_plan = opts.sellingPlan;
      return Cart._post('cart/add.js', { items: [item] }).then(function (json) {
        var id = Cart._sectionId();
        var html = json.sections && id ? json.sections[id] : null;
        var after = html ? Promise.resolve(Cart._apply(html, true)) : Cart.refresh(true);
        return after.then(function () {
          if (opts.open !== false) Cart.open();
          fire('bisou:added', { itemCount: Cart.itemCount, source: opts.source || 'api' });
          return { itemCount: Cart.itemCount };
        });
      }).catch(function (err) {
        fire('bisou:error', { message: err.message });
        throw err;
      });
    },
    change: function (key, quantity) {
      var body = $('[data-bt-cart-body]');
      if (body) body.setAttribute('aria-busy', 'true');
      return Cart._post('cart/change.js', { id: String(key), quantity: Number(quantity) }).then(function (json) {
        var id = Cart._sectionId();
        var html = json.sections && id ? json.sections[id] : null;
        return html ? Cart._apply(html, false) : Cart.refresh(false);
      }).catch(function (err) {
        fire('bisou:error', { message: err.message });
        return Cart.refresh(false).then(function () {
          var live = $('[data-bt-cart-error]');
          if (live) live.textContent = err.message;
        });
      }).then(function () {
        var b = $('[data-bt-cart-body]');
        if (b) b.removeAttribute('aria-busy');
      });
    }
  };
  window.BisouCart = Cart;

  /* add-to-cart buttons */
  function flashLabel(btn, text, ms) {
    var label = $('[data-bt-label]', btn) || btn;
    if (btn.__btOrig === undefined) btn.__btOrig = label.textContent;
    label.textContent = text;
    clearTimeout(btn.__btT);
    btn.__btT = setTimeout(function () { label.textContent = btn.__btOrig; btn.__btOrig = undefined; btn.removeAttribute('data-added'); }, ms);
  }
  function addFromButton(btn, vid, qty, props, plan) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    Cart.add(vid, qty, { properties: props, sellingPlan: plan, source: 'button' }).then(function () {
      btn.setAttribute('data-added', 'true');
      flashLabel(btn, btn.getAttribute('data-added-label') || 'Added', 1800);
    }).catch(function (err) {
      flashLabel(btn, btn.getAttribute('data-error-label') || 'Unavailable', 2400);
      btn.title = err.message || '';
    }).then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ------------------------------------------------------------ events */
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    var add = t.closest('[data-bt-add]');
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute('data-variant-id');
      if (vid) addFromButton(add, vid, add.getAttribute('data-quantity') || 1);
      return;
    }
    var cartBtn = t.closest('[data-bt-cart-open]');
    if (cartBtn && !(e.metaKey || e.ctrlKey || e.shiftKey)) {
      var onCartPage = window.location.pathname.replace(/\/$/, '') === (ROOT + 'cart').replace(/\/$/, '');
      if (!onCartPage && drawerEl('cart')) { e.preventDefault(); openDrawer('cart'); return; }
    }
    var menuBtn = t.closest('[data-bt-menu-open]');
    if (menuBtn) { e.preventDefault(); openDrawer('menu'); return; }

    var searchBtn = t.closest('[data-bt-search-toggle]');
    if (searchBtn) {
      e.preventDefault();
      closeDrawer('menu', true);
      setSearch(!root.classList.contains('bt-search-open'));
      return;
    }
    if (t.closest('[data-bt-close]')) {
      e.preventDefault();
      var d = t.closest('[data-bt-drawer]');
      if (d) closeDrawer(d.getAttribute('data-bt-drawer')); else closeAll();
      return;
    }
    var trig = t.closest('[data-bt-mega-trigger]');
    if (trig && coarse && !root.classList.contains('bt-mega-open')) { e.preventDefault(); setMega(true); return; }

    var qty = t.closest('[data-bt-qty]');
    if (qty) {
      e.preventDefault();
      Cart.change(qty.getAttribute('data-key'), parseInt(qty.getAttribute('data-qty'), 10));
      return;
    }
    var rem = t.closest('[data-bt-remove]');
    if (rem) { e.preventDefault(); Cart.change(rem.getAttribute('data-key'), 0); return; }

    if (t.closest('[data-bt-drawer="menu"] a')) closeDrawer('menu', true);
    if (root.classList.contains('bt-search-open') && !t.closest('[data-bt-search]')) setSearch(false);
    if (root.classList.contains('bt-mega-open') && !t.closest('[data-bt-header]')) setMega(false);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.hasAttribute('data-bt-add-form')) return;
    e.preventDefault();
    var fd = new FormData(f), props = {}, has = false;
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && v !== '') { props[m[1]] = v; has = true; }
    });
    var btn = $('[type="submit"]', f);
    if (!fd.get('id')) return;
    if (btn) addFromButton(btn, fd.get('id'), fd.get('quantity') || 1, has ? props : null, fd.get('selling_plan'));
    else Cart.add(fd.get('id'), fd.get('quantity') || 1, { properties: has ? props : null });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (isOpen('cart') || isOpen('menu') || root.classList.contains('bt-search-open') || root.classList.contains('bt-mega-open')) {
        closeAll();
        return;
      }
    }
    if (e.key === 'Tab') {
      var name = isOpen('cart') ? 'cart' : isOpen('menu') ? 'menu' : null;
      if (!name) return;
      var d = drawerEl(name);
      var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', d).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* mega menu: hover to open (desktop), focus to open (keyboard) */
  document.addEventListener('mouseover', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t || window.innerWidth < 960 || coarse) return;
    if (t.closest('[data-bt-mega-trigger]')) { setSearch(false); setMega(true); return; }
    if (t.closest('[data-bt-nav-link]')) setMega(false);
  });
  document.addEventListener('mouseout', function (e) {
    var h = $('[data-bt-header]');
    if (!h || !root.classList.contains('bt-mega-open')) return;
    var to = e.relatedTarget;
    if (to && h.contains(to)) return;
    if (e.target instanceof Element && h.contains(e.target)) setMega(false);
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-bt-mega-trigger]')) setMega(true);
    else if (root.classList.contains('bt-mega-open') && !t.closest('[data-bt-mega]')) setMega(false);
  });

  /* "bisou:add" (the mockups' add hook) */
  window.addEventListener('bisou:add', function (e) {
    var d = (e && e.detail) || {};
    var vid = d.id || d.variantId;
    if (vid) {
      Cart.add(vid, d.quantity || d.qty || 1, { properties: d.properties, sellingPlan: d.sellingPlan, source: d.source || 'event' }).catch(function () {});
    } else {
      Cart.refresh(true).then(function () { Cart.open(); });
    }
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    syncHeaderHeight();
    if (window.innerWidth >= 960 && isOpen('menu')) closeDrawer('menu', true);
    if (window.innerWidth < 960) setMega(false);
  }, { passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(false); });

  /* ------------------------------------------------------------ init (+ theme editor) */
  function init() {
    onScroll();
    initAnnounce();
    observeHeader();
    var r = $('[data-bt-cart-root]');
    if (r) Cart.itemCount = parseInt(r.getAttribute('data-item-count'), 10) || 0;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', syncHeaderHeight);
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bt-cart-root]')) openDrawer('cart');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bt-cart-root]')) closeDrawer('cart', true);
  });
})();
